export default __webpack_public_path__ + "static/media/two_coming_soon.f6e92d35.png";